import { request } from "http";
import { IApiResponse } from "src/network/models/ApiResponse";

interface IPricingInputRequest {
    firstName: string;
    lastName: string;
    email: string;
}

interface IPricingInputResponse {
    emailId: string;
    isInvited: boolean;
}

interface IOtpVerificationRequest {
    email: string;
    otp: string;
}

interface IOtpVerificationResponse {
    result: string;
}

export class PricingCalculatorViewModel {
    async submitCalculatorUser(
        firstName: string,
        lastName: string,
        emailId: string
    ): Promise<{ result?: IPricingInputResponse; error?: string }> {
        const URL = `https://${process.env.REACT_APP_BE_DOMAIN}/accounting/pricing`;
        const requestBody: IPricingInputRequest = {
            firstName,
            lastName,
            email: emailId
        };

        try {
            const response = await fetch(URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                return { error: `HTTP Error: ${response.status}` };
            }

            const responseObject: IApiResponse<IPricingInputResponse> = await response.json();

            console.log("responseObject =", responseObject);

            if (responseObject && responseObject.scResponse?.code === 2000) {
                return { result: responseObject.scResponse.data }; // ✅ Return actual response data
            } else {
                return { error: responseObject.scResponse?.message || "Unexpected response format" };
            }
        } catch (error) {
            console.error("Error submitting user data:", error);
            return {
                error: "There was an error performing the operation",
            };
        }
    }

    async verifyOtp(emailId: string, otp: string): Promise<{ result?: string; error?: string }> {
        const URL = `https://${process.env.REACT_APP_BE_DOMAIN}/accounting/verify-otp`;

        const requestBody: IOtpVerificationRequest = {
            email: emailId,
            otp: otp
        }

        try {
            const response = await fetch(URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                return { error: `HTTP Error: ${response.status}` };
            }

            const responseObject: IApiResponse<IOtpVerificationResponse> = await response.json();

            console.log("responseObject =", responseObject);

            if (responseObject && responseObject.scResponse?.code === 2000) {
                return { result: responseObject.scResponse.data.result }; // ✅ Return actual response data
            } else {
                return { error: responseObject.scResponse?.message || "Unexpected response format" };
            }
        } catch (error) {
            console.error("Error submitting user data:", error);
            return {
                error: "There was an error performing the operation",
            };
        }
    }
}